import { Component, signal } from '@angular/core'
import { LoadingSpinnerService } from './loading-spinner.service'
import { SpinnerComponent } from './spinner.component'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

// spinner component that is invisible while the global spinner is active
@Component({
  selector: 'app-autohide-spinner',
  imports: [SpinnerComponent],
  template: `
    <app-spinner [class.invisible]="globalSpinnerActive()"/>
  `,
})
export class AutoHideSpinnerComponent {
  protected readonly globalSpinnerActive = signal(false)

  constructor(loadingSpinnerService: LoadingSpinnerService) {
    loadingSpinnerService.showSpinner.pipe(takeUntilDestroyed()).subscribe(active => {
      this.globalSpinnerActive.set(active)
    })
  }
}
